export default __webpack_public_path__ + "static/media/logo-sicc-pt-br.f7808a4a.png";